const DRILL_TYPE = {
  MULT_GRID: 2,
  GENERIC_DRILL: 3,
};

module.exports = {
  DRILL_TYPE,
};
